/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core';
import DatePicker from 'components/molecules/DatePicker';
import { parseDateStr, toDateStr } from 'domain/attend/shiftBoard/time';

/**
 * カレンダーを画面の中に収める（10/6）。react-datepicker の既定は escapeWithReference: true で、はみ出しを防がない。
 * 期間指定の終了日のように入力欄が画面の右端に近いと、カレンダーが右に切れていた
 */
const KEEP_IN_VIEWPORT = {
  preventOverflow: {
    enabled: true, escapeWithReference: false, boundariesElement: 'viewport' as const, padding: 8,
  },
};

/**
 * シフト編成（新）の日付入力（10/6）
 *
 * 月次帳票などと同じアプリ共通のカレンダー（DatePicker）を、盤面の日付の持ち方（'YYYY-MM-DD' の文字列）で使う。
 * 以前はブラウザ標準の <input type="date"> で、カレンダーの見た目がほかの画面と違っていた。
 * DatePicker は入力欄から離れたときに読めない値だと null を返すので、null は無視する（選び直さない限り値は変わらない）。
 */
const BoardDatePicker: React.FC<{
  id?: string;
  /** 'YYYY-MM-DD'。空なら未選択 */
  value: string;
  onChange: (value: string) => void;
  /** 選べる最初の日（'YYYY-MM-DD'） */
  min?: string;
  /** 選べる最後の日（'YYYY-MM-DD'） */
  max?: string;
  /** 枠の高さ（px）。並べるボタン・入力欄の高さに合わせる */
  height?: number;
  /** ダイアログの中で使うとき true。ダイアログの本文はスクロールするので、カレンダーを画面に対して出して切れないようにする */
  inModal?: boolean;
}> = ({
  id, value, onChange, min, max, height = 36, inModal = false,
}) => (
  <DatePicker
    id={id}
    date={value ? parseDateStr(value) : undefined}
    changeDate={(d: Date | null) => {
      if (d) {
        onChange(toDateStr(d));
      }
    }}
    minDate={min ? parseDateStr(min) : undefined}
    maxDate={max ? parseDateStr(max) : undefined}
    positionFixed={inModal}
    popperModifiers={KEEP_IN_VIEWPORT}
    customStyle={css({ height: `${height}px`, background: '#fff' })}
  />
);

export default BoardDatePicker;
